import React, { FunctionComponent } from "react";
import { Box, MenuItem, Stack } from "@mui/material";
import styles from "./styles.module.scss";
import { ContainedButton } from "../../ContainedButton";
import { strings } from "../../../localization/LocalizedStrings";
import { Icon, IconType } from "../../../icons";

export const NewSelectItem: FunctionComponent<INewSelectItemProps> = ({ key, onClickCapture }) => {
  return (
    <MenuItem key={key} className={styles.menuItem} onClickCapture={onClickCapture} disableRipple>
      <ContainedButton className={styles.button}>
        <Stack direction={"row"} alignItems={"center"}>
          <Icon type={IconType.AddCircle} />
          <Box style={{ width: "6px" }} />
          {strings.new}
        </Stack>
      </ContainedButton>
    </MenuItem>
  );
};

interface INewSelectItemProps {
  key: string;
  onClickCapture: (event: React.MouseEvent) => void;
}
